"use strict";

(function () {
  function init() {
    var section = document.querySelector(".ai-graph__section");
    if (!section) return;
    var line = section.querySelector(".ai-graph__line");
    var cards = Array.prototype.slice.call(section.querySelectorAll(".ai-graph__plot .graph-card"));
    if (!line && !cards.length) return;
    var ticking = false;
    var desktop = window.matchMedia("(min-width: 992px)");
    var pinRange = null;
    var pinTop = 0;
    var pinDistance = 0;
    var originalPosition = section.style.position;
    var originalTop = section.style.top;
    function measurePin() {
      if (!pinRange) return;
      var height = section.offsetHeight;
      // Pin only after the section's bottom reaches the viewport bottom.
      // Negative sticky offsets let tall sections scroll into view first.
      pinTop = window.innerHeight - height;
      pinDistance = Math.max(window.innerHeight, cards.length * 300);
      section.style.top = pinTop + "px";
      pinRange.style.height = height + pinDistance + "px";
    }
    function configurePin() {
      if (desktop.matches) {
        if (!pinRange) {
          pinRange = document.createElement("div");
          pinRange.className = "ai-graph__scroll-range";
          // Critical CSS can apply content-visibility to direct section siblings.
          // Sticky positioning needs this range to remain uncontained.
          pinRange.style.contentVisibility = "visible";
          pinRange.style.containIntrinsicSize = "none";
          section.parentNode.insertBefore(pinRange, section);
          pinRange.appendChild(section);
          section.style.position = "sticky";
        }
        measurePin();
      } else if (pinRange) {
        section.style.position = originalPosition;
        section.style.top = originalTop;
        pinRange.parentNode.insertBefore(section, pinRange);
        pinRange.remove();
        pinRange = null;
      }
      onScroll();
    }
    function getProgress() {
      if (pinRange && pinDistance > 0) {
        return Math.min(1, Math.max(0, (pinTop - pinRange.getBoundingClientRect().top) / pinDistance));
      }
      var span = window.innerHeight * 0.5;
      if (span <= 0) return 0;
      var rect = section.getBoundingClientRect();
      var middle = rect.top + 3 / 4 * rect.height;
      var scrolled = window.innerHeight - middle;
      return Math.min(1, Math.max(0, scrolled / span));
    }
    function updateCards(progress) {
      if (!cards.length) return;
      var step = 100 / (cards.length + 1);
      var percent = progress * 100;
      var reachedIndex = -1;
      for (var i = 0; i < cards.length; i++) {
        if (percent >= step * (i + 1)) {
          reachedIndex = i;
        }
      }
      for (var j = 0; j < cards.length; j++) {
        var activeUntil = step * (j + 1.5);
        var isActive = j === reachedIndex && (j === cards.length - 1 || percent < activeUntil);
        cards[j].classList.toggle("active", isActive);
        cards[j].classList.toggle("empty", j > reachedIndex);
      }
    }
    function update() {
      var progress = getProgress();
      if (line) {
        line.style.setProperty("--saai-progress", progress * 100 + "%");
      }
      updateCards(progress);
    }
    function onScroll() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(function () {
        update();
        ticking = false;
      });
    }
    configurePin();
    update();
    window.addEventListener("scroll", onScroll, {
      passive: true
    });
    window.addEventListener("resize", configurePin);
    window.addEventListener("load", configurePin);
    desktop.addEventListener("change", configurePin);
    if ("ResizeObserver" in window) {
      new ResizeObserver(function () {
        measurePin();
        onScroll();
      }).observe(section);
    }
  }
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
(function () {
  var MEDIA_TIMEOUT = 4000;
  var TARGETS = [{
    root: ".meet-saai",
    target: ".meet-saai__visual",
    threshold: 0.75,
    onReady: prepareSaaiTitle,
    onStart: playSaaiChat
  }, {
    root: ".eco-diagram-wrap",
    target: null,
    threshold: 0.5
  }, {
    root: ".marketing-automation-anim-block",
    target: null,
    threshold: 0.5
  }];
  function whenMediaReady(block, cb) {
    var imgs = block.getElementsByTagName("img");
    var pending = 0;
    var fired = false;
    var i;
    function finish() {
      if (fired) return;
      fired = true;
      cb();
    }
    function done() {
      if (--pending <= 0) finish();
    }
    for (i = 0; i < imgs.length; i++) {
      if (imgs[i].complete || !imgs[i].getClientRects().length) continue;
      pending++;
      imgs[i].addEventListener("load", done, {
        once: true
      });
      imgs[i].addEventListener("error", done, {
        once: true
      });
      if (imgs[i].loading === "lazy") imgs[i].loading = "eager";
    }
    if (pending === 0) finish();else setTimeout(finish, MEDIA_TIMEOUT);
  }
  function splitChars(el) {
    var text = el.textContent.replace(/\s+/g, " ").trim();
    var chars = [];
    var i;
    el.textContent = "";
    for (i = 0; i < text.length; i++) {
      var ch = document.createElement("span");
      ch.className = "meet-saai__char";
      ch.textContent = text[i];
      el.appendChild(ch);
      chars.push(ch);
    }
    return chars;
  }
  function prepareSaaiTitle(block) {
    var title = block.querySelector(".meet-saai__title");
    if (!title) return;
    title.setAttribute("aria-label", title.textContent.replace(/\s+/g, " ").trim());
    block._saaiLines = Array.prototype.map.call(title.children, splitChars);
  }
  function playSaaiChat(block) {
    var title = block.querySelector(".meet-saai__title");
    var lines = (block._saaiLines || []).filter(function (l) {
      return l.length;
    });
    prepareSaaiAgentCycle(block);
    block.classList.add("is-chat");
    if (!title || !lines.length) {
      block.classList.add("is-chat");
      return;
    }

    // Only the heading types; the description fades in on the CSS timeline.
    lines.slice(1).forEach(function (line) {
      line.forEach(function (ch) {
        ch.classList.add("is-on");
      });
    });
    var chars = lines[0];
    var startedAt = performance.now();
    var shown = 0;
    function type(now) {
      var count = Math.min(chars.length, Math.max(1, Math.floor((now - startedAt) / 300 * chars.length)));
      while (shown < count) chars[shown++].classList.add("is-on");
      if (shown < chars.length) requestAnimationFrame(type);
    }
    type(startedAt);
  }
  function prepareSaaiAgentCycle(block) {
    var list = block.querySelector(".meet-saai__agents");
    var bubble = block.querySelector(".meet-saai__bubble");
    var input = block.querySelector(".meet-saai__input");
    var agents = Array.prototype.slice.call(block.querySelectorAll(".agent-item[data-saai-prompt]"));
    if (!list || !bubble || !input || !agents.length) return;
    var avatar = input.querySelector("img");
    var text = input.querySelector(".meet-saai__input-text");
    if (!avatar || !text || !avatar.animate) return;

    // Overlapping, invisible grid items reserve the longest mobile prompt's height.
    // They reflow with the field on resize without changing the animation clock.
    agents.forEach(function (agent) {
      var measure = document.createElement("span");
      measure.className = "meet-saai__input-measure";
      measure.textContent = agent.getAttribute("data-saai-prompt");
      input.appendChild(measure);
    });

    // One clock drives every phase, so typing and both animations pause together.
    // Highlight: 0; avatar: 200–500; type: 500–1000; hold: 1000–3000;
    // Text rises: 3000–3500; drifts right: 3500–4200;
    // avatar exits: 4200–4500; next agent: 4500 ms.
    var step = 4500;
    var elapsed = 0;
    var lastTime = 0;
    var frame = null;
    var ready = false;
    var visible = false;
    var active = -1;
    var avatarAnimation;
    var textAnimation;
    function createAnimations() {
      avatarAnimation = avatar.animate([{
        transform: "scale(0)",
        offset: 0
      }, {
        transform: "scale(0)",
        offset: 200 / step,
        easing: "ease-out"
      }, {
        transform: "scale(1.05)",
        offset: 400 / step,
        easing: "ease-in-out"
      }, {
        transform: "scale(1)",
        offset: 500 / step
      }, {
        transform: "scale(1)",
        offset: 4200 / step,
        easing: "ease-out"
      }, {
        transform: "scale(0)",
        offset: 1
      }], {
        duration: step,
        fill: "both"
      });
      textAnimation = text.animate([{
        transform: "translateY(0)",
        filter: "blur(0px)",
        opacity: 1,
        offset: 0
      }, {
        transform: "translateY(0)",
        filter: "blur(0px)",
        opacity: 1,
        offset: 3000 / step,
        easing: "ease-out"
      }, {
        offset: 3500 / step
      }, {
        offset: 4200 / step
      }, {
        transform: "translate(80px, -80px)",
        filter: "blur(10px)",
        opacity: 0,
        offset: 1
      }], {
        duration: step,
        fill: "both"
      });
      avatarAnimation.pause();
      textAnimation.pause();
      input.classList.add("is-cycling");
    }
    function render() {
      var index = Math.floor(elapsed / step) % agents.length;
      var time = elapsed % step;
      if (index !== active) {
        if (active !== -1) agents[active].classList.remove("is-active");
        active = index;
        agents[active].classList.add("is-active");
        avatar.src = agents[active].querySelector(".agent-item__avatar img").getAttribute("src");
      }
      var prompt = agents[active].getAttribute("data-saai-prompt");
      var count = Math.floor(prompt.length * Math.min(1, Math.max(0, (time - 500) / 500)));
      var typed = prompt.slice(0, count);
      if (text.textContent !== typed) text.textContent = typed;
      avatarAnimation.currentTime = time;
      textAnimation.currentTime = time;
    }
    function tick() {
      // Use the same clock as start/resume and pause. A rAF timestamp can precede
      // the observer callback that scheduled this frame and yield a negative index.
      var now = performance.now();
      elapsed += now - lastTime;
      lastTime = now;
      render();
      frame = requestAnimationFrame(tick);
    }
    function syncPlayback() {
      var running = ready && visible && !document.hidden;
      if (running && frame === null) {
        if (!avatarAnimation) createAnimations();
        render();
        lastTime = performance.now();
        frame = requestAnimationFrame(tick);
      } else if (!running && frame !== null) {
        elapsed += performance.now() - lastTime;
        cancelAnimationFrame(frame);
        frame = null;
        render();
      }
    }
    list.addEventListener("animationend", function onReveal(event) {
      if (event.target !== list || event.animationName !== "fadeLeft") return;
      list.removeEventListener("animationend", onReveal);
      ready = true;
      syncPlayback();
    });
    new IntersectionObserver(function (entries) {
      visible = entries[0].isIntersecting;
      block.classList.toggle("is-chat-offscreen", !visible);
      syncPlayback();
    }).observe(bubble);
    document.addEventListener("visibilitychange", syncPlayback);
  }
  var ORBIT = {
    heads: [26.6, 80.5],
    length: 14,
    cycle: 6,
    core: {
      steps: 14,
      width: 2,
      from: [51, 133, 255],
      to: [10, 145, 255],
      max: 1
    },
    glow: {
      steps: 8,
      width: [3, 9],
      share: 0.5,
      color: [105, 188, 255],
      max: 0.14
    }
  };
  function orbitLayers() {
    var layers = [];
    var i, t, c;
    function stepOpacity(k, n, max) {
      return max / n / (1 - (k - 1) * max / n);
    }
    for (i = 1; i <= ORBIT.core.steps; i++) {
      t = (i - 1) / (ORBIT.core.steps - 1);
      c = ORBIT.core.from.map(function (v, j) {
        return Math.round(v + (ORBIT.core.to[j] - v) * t);
      });
      layers.push({
        len: ORBIT.length * (ORBIT.core.steps - i + 1) / ORBIT.core.steps,
        width: ORBIT.core.width,
        color: "rgb(" + c.join(",") + ")",
        opacity: stepOpacity(i, ORBIT.core.steps, ORBIT.core.max)
      });
    }
    for (i = 1; i <= ORBIT.glow.steps; i++) {
      layers.push({
        len: ORBIT.length * ORBIT.glow.share * (ORBIT.glow.steps - i + 1) / ORBIT.glow.steps,
        width: ORBIT.glow.width[0] + (ORBIT.glow.width[1] - ORBIT.glow.width[0]) * (i - 1) / (ORBIT.glow.steps - 1),
        color: "rgb(" + ORBIT.glow.color.join(",") + ")",
        opacity: stepOpacity(i, ORBIT.glow.steps, ORBIT.glow.max)
      });
    }
    return layers;
  }
  function drawOrbit(bubble) {
    var svg = bubble.querySelector(".meet-saai__orbit");
    if (!svg) return;
    var gapA = ORBIT.heads[1] - ORBIT.heads[0];
    var gapB = 100 - gapA;
    var paths = orbitLayers().map(function (l) {
      var path = document.createElementNS("http://www.w3.org/2000/svg", "path");
      var r = function r(v) {
        return Math.round(v * 1000) / 1000;
      };
      path.setAttribute("pathLength", "100");
      path.setAttribute("stroke", l.color);
      path.setAttribute("stroke-width", l.width);
      path.setAttribute("stroke-opacity", r(l.opacity));
      path.setAttribute("stroke-dasharray", [l.len, gapA - l.len, l.len, gapB - l.len].map(r).join(" "));
      path.setAttribute("stroke-dashoffset", r(l.len - ORBIT.heads[0]));
      path.style.animationDelay = r(-(ORBIT.length - l.len) * ORBIT.cycle / 100) + "s";
      svg.appendChild(path);
      return path;
    });
    function draw() {
      var w = bubble.offsetWidth;
      var h = bubble.offsetHeight;
      if (!w || !h) return;
      var cs = window.getComputedStyle(bubble);
      var o = 0.5;
      var r = [cs.borderTopLeftRadius, cs.borderTopRightRadius, cs.borderBottomRightRadius, cs.borderBottomLeftRadius].map(function (v) {
        return Math.max(0, parseFloat(v) - o) || 0;
      });
      var arc = function arc(rad, x, y) {
        return "A" + rad + " " + rad + " 0 0 1 " + x + " " + y;
      };
      var d = "M" + (o + r[0]) + " " + o + "H" + (w - o - r[1]) + arc(r[1], w - o, o + r[1]) + "V" + (h - o - r[2]) + arc(r[2], w - o - r[2], h - o) + "H" + (o + r[3]) + arc(r[3], o, h - o - r[3]) + "V" + (o + r[0]) + arc(r[0], o + r[0], o) + "Z";
      for (var i = 0; i < paths.length; i++) paths[i].setAttribute("d", d);
    }
    if ("ResizeObserver" in window) new ResizeObserver(draw).observe(bubble);else draw();
  }
  function observe(cfg) {
    var block = document.querySelector(cfg.root);
    if (!block) return;
    var target = cfg.target ? block.querySelector(cfg.target) || block : block;
    var started = false;
    function start() {
      if (started) return;
      started = true;
      whenMediaReady(block, function () {
        block.classList.add("is-animated");
        if (cfg.onStart) cfg.onStart(block);
      });
    }
    if (cfg.onReady) cfg.onReady(block);
    block.classList.add("is-ready");
    new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          block.classList.remove("is-offscreen");
          start();
        } else if (block.classList.contains("is-animated")) {
          block.classList.add("is-offscreen");
        }
      });
    }, {
      threshold: cfg.threshold
    }).observe(target);
    new IntersectionObserver(function (entries) {
      var entry = entries[0];
      if (entry.isIntersecting && entry.boundingClientRect.top < 0) start();
    }).observe(block);
  }
  function init() {
    Array.prototype.forEach.call(document.querySelectorAll(".meet-saai__bubble"), drawOrbit);
    if (!("IntersectionObserver" in window)) return;
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;
    TARGETS.forEach(observe);
  }
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();